import { z } from 'zod';
import { LpInvestorUpdateStatus } from 'further-types/lp/investor-update';
import { CalendarDay } from '../../../utils';
import { blockNoteDocumentSchema } from '../../common/block-note-editor';
import { isMongoId } from '../../helpers';

const toggleableStringSchema = z.object({
  included: z.boolean(),
  value: z.string(),
});

export const fundOverviewDatapointsSchema = z.object({
  general: z.object({
    fundName: toggleableStringSchema,
    fundCurrency: toggleableStringSchema,
    vintageYear: toggleableStringSchema,
    displayCloseDate: toggleableStringSchema,
    totalCommitments: toggleableStringSchema,
    displayTotalCommitmentsPerClose: toggleableStringSchema,
    fundTerm: toggleableStringSchema,
    legalForm: toggleableStringSchema,
    formationJurisdiction: toggleableStringSchema,
    investmentAdviserManager: toggleableStringSchema,
    generalPartner: toggleableStringSchema,
    reinvestmentRecyclingPolicy: toggleableStringSchema,
  }),
  investmentFocus: z.object({
    stage: toggleableStringSchema,
    sector: toggleableStringSchema,
    geography: toggleableStringSchema,
  }),
});

export const SavePeriodEndReport = z.object({
  id: z.string().refine(isMongoId()).optional(),
  vehicleId: z.string().refine(isMongoId()),
  accountingPeriodId: z.string().refine(isMongoId()),
  status: z.nativeEnum(LpInvestorUpdateStatus),
  title: z.string().optional(),
  reportDate: z.instanceof(CalendarDay).optional(),
  commentary: blockNoteDocumentSchema,
  fundOverviewDatapoints: fundOverviewDatapointsSchema,
  portfolioUpdateFile: z
    .object({
      name: z.string(),
      path: z.string(),
    })
    .optional(),
  notificationPreferences: z.object({
    notifyViaEmail: z.boolean(),
    attachPdfUpdateToEmail: z.boolean(),
  }),
  perInvestorNotificationSettings: z.array(
    z.object({
      investorId: z.string().refine(isMongoId()),
      notifyViaEmail: z.boolean(),
    }),
  ),
  resendPublishedUpdates: z.boolean(),
});

export const PublishPeriodEndReport = SavePeriodEndReport.extend({
  id: z.string().refine(isMongoId()),
  title: z.string().min(1, 'Report name is required.'),
  reportDate: z.instanceof(CalendarDay, {
    message: 'Report date is required.',
  }),
});
